export enum StreamChannelType {
  Group = 'messaging-group',
  Private = 'messaging-private',
  Audio = 'messaging',
  Dm = 'messaging-dm',
  GuideCommunity = 'messaging-guide-community',
  Circles = 'messaging-circles',
}

export enum StreamChatRole {
  Admin = 'admin',
  User = 'user',
}

export enum StreamChannelRole {
  ChannelModerator = 'channel_moderator',
  ChannelMember = 'channel_member',
}

// whenever adding a new event, make sure to bump the type package version in "core" and "chat"
export enum SupportedAudioCallEvents {
  ParticipantLeft = 'call.session_participant_left',
  SessionStarted = 'call.session_started',

  RecordingStarted = 'call.recording_started',
  RecordingStopped = 'call.recording_stopped',
  RecordingFailed = 'call.recording_failed',
  RecordingReady = 'call.recording_ready',

  TranscriptionStopped = 'call.transcription_stopped',
  TranscriptionStarted = 'call.transcription_started',
  TranscriptionFailed = 'call.transcription_failed',
  TranscriptionReady = 'call.transcription_ready',
}

export enum SupportedChatEvents {
  MessageNew = 'message.new',
  ReactionNew = 'reaction.new',
}
